import {
  faChartLine,
  faHandHoldingDollar,
  faMoneyBillTransfer,
  faFileArrowUp,
  faFileSignature,
  faGlobe,
  faClockRotateLeft,
  faReceipt,
  faCreditCard,
  faFileLines,
  faGift,
  faHeart,
  faLock,
  faSuitcase,
  faTableCellsLarge,
  faTicket,
  faUser,
  faUsers,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';

import type { AccountSectionId } from './types';

/** One icon per section, shared by the rail, the mobile picker and the Overview quick links. */
export const SECTION_ICONS: Record<AccountSectionId, IconDefinition> = {
  overview: faTableCellsLarge,
  bookings: faSuitcase,
  history: faClockRotateLeft,
  quotes: faFileLines,
  saved: faHeart,
  certificates: faTicket,
  reports: faChartLine,
  commissions: faHandHoldingDollar,
  cashout: faMoneyBillTransfer,
  cashoutHistory: faReceipt,
  website: faGlobe,
  manualUpload: faFileArrowUp,
  supplier: faFileSignature,
  profile: faUser,
  authorized: faUsers,
  payment: faCreditCard,
  password: faLock,
  sidekick: faGift,
};
